import { STORE_ROUTE_NAME } from '@/libs/route-name';

export const storeRoute = () => {
    return {
        name: STORE_ROUTE_NAME.STORE,
        path: 'store',
        component: () => import('@/pages/store/index.vue'),
    };
};

export const storeDetailRoute = () => {
    return {
        name: STORE_ROUTE_NAME.STORE_DETAIL,
        path: 'store/:id',
        component: () => import('@/pages/store/components/StoreDetail.vue'),
        props: true,
    };
};
